import { createBrowserRouter } from 'react-router-dom'
import { Admin } from './components/admin'
import { Form } from './components/form'
import { Thanks } from './components/thanks'

export const router = createBrowserRouter([
  {
    element: <Admin />,
    path: '/admin',
  },
  {
    element: <Form />,
    path: '/',
  },
  {
    element: <Thanks />,
    path: '/thanks',
  },
])
